/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PackageStatusUpdate } from './PackageStatusUpdate';
import {
    PackageStatusUpdateFromJSON,
    PackageStatusUpdateFromJSONTyped,
    PackageStatusUpdateToJSON,
} from './PackageStatusUpdate';

/**
 * 
 * @export
 * @interface ListPackageStatusUpdatesResponseBody
 */
export interface ListPackageStatusUpdatesResponseBody {
    /**
     * 
     * @type {Array<PackageStatusUpdate>}
     * @memberof ListPackageStatusUpdatesResponseBody
     */
    items: Array<PackageStatusUpdate>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListPackageStatusUpdatesResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListPackageStatusUpdatesResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListPackageStatusUpdatesResponseBody interface.
 */
export function instanceOfListPackageStatusUpdatesResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListPackageStatusUpdatesResponseBodyFromJSON(json: any): ListPackageStatusUpdatesResponseBody {
    return ListPackageStatusUpdatesResponseBodyFromJSONTyped(json, false);
}

export function ListPackageStatusUpdatesResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPackageStatusUpdatesResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PackageStatusUpdateFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListPackageStatusUpdatesResponseBodyToJSON(value?: ListPackageStatusUpdatesResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(PackageStatusUpdateToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

